/// <reference path="wpt.ts" />
// Scenarios:
// - View keys for existing document: Get existing keys and their types.
// - Edit keys for existing document: May get types with no existing key.
// - Enter keys for new document: Will get types (and groups) with no existing key.
// - Enter keys for search: As new document but no groups.
var WPTNamespace;
(function (WPTNamespace) {
    var MetadataEditors;
    (function (MetadataEditors) {
        const LOG_CATEGORY = "WPT.MetadataEditors.Keywords";
        let MetadataKeywordDataType;
        (function (MetadataKeywordDataType) {
            MetadataKeywordDataType["UNKNOWN"] = "UNKNOWN";
            MetadataKeywordDataType["ALPHANUMERIC"] = "ALPHANUMERIC";
            MetadataKeywordDataType["CURRENCY"] = "CURRENCY";
            MetadataKeywordDataType["DATE"] = "DATE";
            MetadataKeywordDataType["DATERANGE"] = "DATERANGE";
            MetadataKeywordDataType["DATETIME"] = "DATETIME";
            MetadataKeywordDataType["FLOAT"] = "FLOAT";
            MetadataKeywordDataType["NUMERIC"] = "NUMERIC";
            MetadataKeywordDataType["DATASET"] = "DATASET";
        })(MetadataKeywordDataType = MetadataEditors.MetadataKeywordDataType || (MetadataEditors.MetadataKeywordDataType = {}));
        let KeywordEditMode;
        (function (KeywordEditMode) {
            KeywordEditMode["EDIT"] = "EDIT";
            KeywordEditMode["SEARCH"] = "SEARCH";
            KeywordEditMode["UPLOAD"] = "UPLOAD";
            KeywordEditMode["VIEW"] = "VIEW";
        })(KeywordEditMode = MetadataEditors.KeywordEditMode || (MetadataEditors.KeywordEditMode = {}));
        // And/Or
        class MetadataRelationButton {
            constructor(core, container) {
                this._core = null;
                this._log = null;
                this._index = 0;
                this._button = null;
                this._labelSpan = null;
                this._cycle = () => {
                    this._log.info("MetadataRelationButton._cycle()");
                    this._index++;
                    if (this._index >= MetadataRelationButton._states.length)
                        this._index = 0;
                    this._labelSpan.innerText = MetadataRelationButton._labels[this._index];
                };
                this.show = () => {
                    this._core.Functions.showElement(this._button);
                };
                this.hide = () => {
                    this._core.Functions.hideElement(this._button);
                };
                this._core = core;
                this._log = core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("MetadataRelationButton::constructor");
                // Need translations
                if ((MetadataRelationButton._labels == null) || (MetadataRelationButton._labels.length == 0)) {
                    MetadataRelationButton._labels = [];
                    MetadataRelationButton._labels.push(core.Locale.getTranslation('STR_WPT_RELATION_AND'));
                    MetadataRelationButton._labels.push(core.Locale.getTranslation('STR_WPT_RELATION_OR'));
                }
                this._button = document.createElement('button');
                this._button.type = 'button';
                this._button.classList.add('kw-relation-button', 'wpt-button', 'wpt-button--accent');
                this._labelSpan = document.createElement('span');
                this._labelSpan.classList.add('wpt-button__text');
                this._labelSpan.innerText = MetadataRelationButton._labels[0];
                this._button.addEventListener('click', this._cycle);
                this._button.appendChild(this._labelSpan);
                container.appendChild(this._button);
            }
            get Relation() {
                return MetadataRelationButton._states[this._index];
            }
        }
        MetadataRelationButton._states = ['and', 'or'];
        MetadataEditors.MetadataRelationButton = MetadataRelationButton;
        // =, !=, >, <, >=, <=
        class MetadataOperatorButton {
            constructor(core, container, dataType = "alphanumeric") {
                // State strings are the ones used in search conditions
                this._core = null;
                this._log = null;
                this._labels = null;
                this._states = null;
                this._index = 0;
                this._iconDiv = null;
                this._icon = null;
                this._cycle = () => {
                    this._log.info("MetadataOperatorButton._cycle()");
                    this._index++;
                    if (this._index >= this._states.length)
                        this._index = 0;
                    this._icon.innerHTML = this._labels[this._index];
                };
                this.show = () => {
                    this._log.info("MetadataOperatorButton.show()");
                    this._core.Functions.showElement(this._iconDiv);
                };
                this.hide = () => {
                    this._log.info("MetadataOperatorButton.hide()");
                    this._core.Functions.hideElement(this._iconDiv);
                };
                this._core = core;
                this._log = core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("MetadataOperatorButton::constructor");
                if (dataType.toLowerCase() == "alphanumeric") {
                    this._labels = ['=', '&lt;&gt;', '&quot;&quot;'];
                    this._states = ['=', '<>', '==='];
                }
                else {
                    this._labels = ['=', '&lt;&gt;', '&gt;', '&lt;', '&ge;', '&le;'];
                    this._states = ['=', '<>', '>', '<', '>=', '<='];
                }
                this._iconDiv = document.createElement('div');
                this._iconDiv.classList.add('wpt-input__icons', 'wpt-input__icons--first');
                if (container.hasChildNodes()) {
                    container.insertBefore(this._iconDiv, container.firstChild);
                }
                else {
                    container.appendChild(this._iconDiv);
                }
                this._icon = document.createElement('span');
                this._icon.classList.add("wpt-input__icons-item", "wpt-input__icons-item--hover-primary");
                this._icon.innerHTML = this._labels[0];
                this._icon.addEventListener('click', this._cycle);
                this._iconDiv.appendChild(this._icon);
            }
            get Operator() {
                return this._states[this._index];
            }
        }
        MetadataEditors.MetadataOperatorButton = MetadataOperatorButton;
        class KeywordEditorWrapper {
            // Ideally, keyword type should be explicitly from doc type, as this populates RequiredForX parameters
            constructor(core, form, container, insertAfter, keyInstance, keyType, owner, simple = false, callbacks = {}, mode = KeywordEditMode.SEARCH) {
                this._core = null;
                this._log = null;
                this._editor = null;
                this._form = null;
                this._container = null;
                this._insertAfter = null;
                this._outerElement = null;
                this._label = null;
                this._callbacks = {};
                this._editMode = null;
                this._keyInstance = null;
                this._keyType = null;
                this._suppressButtons = false;
                this._simpleDisplay = false;
                // UI components
                this._opButton = null;
                this._relButton = null;
                this._addButton = null;
                // Build wrapper interface. Note we expect our container to be in a document fragment
                // so we don't use one explicitly here.
                // TODO - Ensure we *are* called using a fragment for the build
                this._buildInterface = () => {
                    this._log.info("KeywordEditorWrapper::_buildInterface");
                    this._outerElement = document.createElement('li');
                    this._outerElement.classList.add('keywordeditor-item__container', 'wpt-form-item');
                    // Split into two DIVs - one at the top for controls, one under for actual editor
                    let topDiv = document.createElement('div');
                    topDiv.classList.add('keywordeditor-sublist');
                    let leftSpan = document.createElement('span');
                    leftSpan.classList.add('keywordeditor-item__leftspan');
                    if (!this._suppressButtons) {
                        if (!this._simpleDisplay)
                            this._relButton = new MetadataRelationButton(this._core, leftSpan);
                    }
                    this._label = document.createElement('label');
                    this._label.classList.add('wpt-form-item-label__text');
                    this._label.innerText = this._keyType.TranslatedName; // Possibly updated shortly by _applyEditMode()
                    leftSpan.appendChild(this._label);
                    topDiv.appendChild(leftSpan);
                    // Right Span just for add button
                    let rightSpan = document.createElement('span');
                    rightSpan.classList.add('keywordeditor-item__rightspan');
                    if (!this._suppressButtons) {
                        this._addButton = document.createElement('span');
                        this._addButton.classList.add('wpt-font', 'wpt-font-add_box', 'keywordrecord-item__icon', 'kweditor-span-button');
                        this._addButton.addEventListener('click', this._keywordAddClicked);
                        rightSpan.appendChild(this._addButton);
                    }
                    topDiv.appendChild(rightSpan);
                    this._outerElement.appendChild(topDiv);
                    // Create editor div and insert editor subcomponent
                    let editDiv = document.createElement('div');
                    editDiv.classList.add('keywordeditor', 'keywordeditor-sublist');
                    let value = (this._keyInstance) ? this._keyInstance.Value : null;
                    this._editor = KeywordEditor.CreateEditor(this._core, this._form, editDiv, null, this._keyType, value, this._editMode, this._callbacks.DataChangedCallback);
                    this._outerElement.appendChild(editDiv);
                    if (!this._suppressButtons && !this._simpleDisplay)
                        this._opButton = new MetadataOperatorButton(this._core, this._editor.InputDiv, this._keyType.Type);
                    this._applyEditMode();
                    if (this._insertAfter && this._insertAfter.nextSibling != null) {
                        this._container.insertBefore(this._outerElement, this._insertAfter.nextSibling);
                    }
                    else
                        this._container.appendChild(this._outerElement);
                };
                this._keywordAddClicked = (event) => {
                    if (this._callbacks.RowAddedCallback) {
                        this._callbacks.RowAddedCallback(this._keyType, this._outerElement);
                    }
                };
                this._applyEditMode = () => {
                    this._log.info("KeywordEditorWrapper._applyEditMode()");
                    if (this.IsMandatory) {
                        this._label.classList.add('wpt-form-item-label__text--required');
                    }
                    else {
                        this._label.classList.remove('wpt-form-item-label__text--required');
                    }
                    this._editor.Mode = this._editMode;
                    switch (this._editMode) {
                        case KeywordEditMode.VIEW:
                            if ((this._owner.RecordGroupType == `StandAlone`) && (!this._editor.Value)) {
                                this._core.Functions.hideElement(this._outerElement);
                            }
                            else
                                this._core.Functions.showElement(this._outerElement);
                            if (this._opButton)
                                this._opButton.hide();
                            if (this._relButton)
                                this._relButton.hide();
                            if (this._addButton)
                                this._core.Functions.hideElement(this._addButton);
                            break;
                        case KeywordEditMode.EDIT:
                            this._core.Functions.showElement(this._outerElement);
                            if (this._owner.RecordGroupType == 'StandAlone') {
                                if (this._addButton)
                                    this._core.Functions.showElement(this._addButton);
                            }
                            else {
                                if (this._addButton)
                                    this._core.Functions.hideElement(this._addButton);
                            }
                            if (this._opButton)
                                this._opButton.hide();
                            if (this._relButton)
                                this._relButton.hide();
                            break;
                        case KeywordEditMode.SEARCH:
                            // Should only ever have standalone keywords here
                            if (this._owner.RecordGroupType == `StandAlone`) {
                                this._core.Functions.showElement(this._outerElement);
                                if (this._opButton)
                                    this._opButton.show();
                                if (this._relButton)
                                    this._relButton.show();
                                if (this._addButton)
                                    this._core.Functions.showElement(this._addButton);
                            }
                            else {
                                console.warn("Attempt to set non-standalone keyword wrapper to search mode.");
                                this._core.Functions.hideElement(this._outerElement);
                            }
                            break;
                        case KeywordEditMode.UPLOAD:
                            this._core.Functions.showElement(this._outerElement);
                            if (this._owner.RecordGroupType == `StandAlone`) {
                                if (this._addButton)
                                    this._core.Functions.showElement(this._addButton);
                            }
                            else {
                                if (this._addButton)
                                    this._core.Functions.hideElement(this._addButton);
                            }
                            if (this._opButton)
                                this._opButton.hide();
                            if (this._relButton)
                                this._relButton.hide();
                            // Insert any defined prefills if keyword value is empty
                            if (!this._editor.Value) {
                                let userVariable = this._core.Context.getArchivePrefillValue(this._keyType.Name);
                                if (userVariable != null)
                                    this._editor.Value = userVariable;
                            }
                            break;
                    }
                };
                this._core = core;
                this._log = core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("KeywordEditorWrapper::constructor");
                this._form = form;
                this._container = container;
                this._owner = owner;
                this._insertAfter = insertAfter;
                this._callbacks = callbacks;
                this._editMode = mode;
                this._simpleDisplay = simple;
                // General sanity checks
                // We might get a type with no instance, or an instance with no type, or both.
                if ((keyInstance == null) && (keyType == null)) {
                    // It's all gone horribly wrong
                    console.warn("Attempt to create keyword editor with no key type or instance.");
                    return;
                }
                // Hopefully we'll not have to pull keyword type from OBHelper cache
                if (keyType == null)
                    this._keyType = this._core.OBHelper.KeywordTypeMap[this._keyInstance.Type];
                else
                    this._keyType = keyType;
                this._keyInstance = keyInstance;
                // Don't want relations and the like hanging off search date fields
                if (['>>DateFrom', '>>DateTo', '>>DateSingle'].indexOf(this._keyType.Name) > -1)
                    this._suppressButtons = true;
                this._buildInterface();
            }
            set KeyUpHandler(handler) {
                if (handler) {
                    this._editor.KeyUpHandler = handler;
                }
            }
            get Mode() { return this._editMode; }
            set Mode(value) {
                if (this._editMode == value)
                    return;
                this._editMode = value;
                this._applyEditMode();
            }
            get KeywordType() { return this._keyType; }
            get Value() { return this._editor.Value; }
            set Value(value) {
                this._editor.Value = value;
            }
            get KeywordInstance() {
                if (this._editor.Value) {
                    let key = {
                        Id: this._keyType.Id,
                        Name: this._keyType.Name,
                        Value: this._editor.Value
                    };
                    return key;
                }
                else
                    return null;
            }
            get FlexTerm() {
                if (this._editor.Value) {
                    let term = {
                        Term: this._keyType.Name,
                        Value: this._editor.Value
                    };
                    if (this._opButton)
                        term.Operator = this._opButton.Operator;
                    if (this._relButton)
                        term.Relation = this._relButton.Relation;
                    return term;
                }
                else
                    return null;
            }
            get IsMandatory() {
                // False if we have no data to go on
                if (!this._keyType || !this._keyType.hasOwnProperty('AccessSettings') || (this._keyType.AccessSettings == null))
                    return false;
                switch (this._editMode) {
                    case KeywordEditMode.SEARCH:
                        return this._keyType.AccessSettings.RequiredForRetrieval;
                        break;
                    case KeywordEditMode.UPLOAD:
                    case KeywordEditMode.EDIT:
                        return this._keyType.AccessSettings.RequiredForArchival;
                        break;
                }
                return false;
            }
            get Valid() {
                if (this.IsMandatory && !this.Value)
                    return false;
                else
                    return true;
            }
            get ReadOnly() {
                // False if we have no data to go on
                if (!this._keyType || !this._keyType.hasOwnProperty('AccessSettings') || (this._keyType.AccessSettings == null) || (this._keyType.AccessSettings.Readonly == null))
                    return false;
                return this._keyType.AccessSettings.Readonly;
            }
        }
        MetadataEditors.KeywordEditorWrapper = KeywordEditorWrapper;
        // Abstract class from which all editors are derived
        // Current plan is that editor is completely embeded in wrapper, only wrapper is created externally
        // Editor MUST HAVE a keyword type
        // Wrapper contains all buttons and functions, these are then hidden/shown according to demand
        class KeywordEditor {
            constructor(core, form, container, id, keyType, value = null, mode = KeywordEditMode.VIEW, changeCallback = null) {
                this._core = null;
                this._log = null;
                this._form = null;
                this._container = null;
                this._outerDiv = null;
                this._input = null;
                this._mode = null;
                this._keyType = null; // Passed-in keyword type, probably from document type or query
                this._masterKeyType = null; // Master definition of keyword type, needed in case of dataset
                this._value = null;
                this._afksId = 0;
                this._isValid = null;
                // Dataset handling
                this._hasDataSet = false;
                this._dataSet = [];
                this._mustExist = false;
                this._keyupCallback = null;
                this._valueSet = (value) => {
                    this.Value = value;
                    if (this._changedCallback)
                        this._changedCallback(this._keyType, this._value);
                };
                this._modeSet = (mode) => {
                    this._mode = mode;
                };
                this._core = core;
                this._log = core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("KeywordEditor::constructor");
                this._keyType = keyType;
                this._masterKeyType = this._core.OBHelper.KeywordTypeMap[this._keyType.Name];
                this._value = value;
                this._form = form;
                this._container = container;
                this._changedCallback = changeCallback;
                this._isValid = true;
                // Autofill handling
                if (keyType.hasOwnProperty('AutofillKeywordSetId') && (keyType.AutofillKeywordSetId != null))
                    this._afksId = keyType.AutofillKeywordSetId;
                // Dataset handling
                if (this._masterKeyType.hasOwnProperty('DataSet') && (this._masterKeyType.DataSet != null) && (this._masterKeyType.DataSet.length > 0)) {
                    this._hasDataSet = true;
                    this._dataSet = this._masterKeyType.DataSet;
                    if (this._masterKeyType.hasOwnProperty('MustExistInDataset') && (this._masterKeyType.MustExistInDataset != null))
                        this._mustExist = this._masterKeyType.MustExistInDataset;
                }
                // Don't call _buildInterface here - it's going to be per descendent class and their constructors might want to do more
            }
            // Accessors to iterate and return
            static get CounterString() {
                KeywordEditor._counter++;
                return KeywordEditor._counter.toString();
            }
            static get CounterValue() {
                KeywordEditor._counter++;
                return KeywordEditor._counter;
            }
            get InputDiv() {
                return this._outerDiv;
            }
            get Mode() { return this._mode; }
            set Mode(mode) {
                if (mode != this._mode)
                    this._modeSet(mode);
            }
            get Value() { return this._value; }
            set Value(value) {
                this._value = value;
                this._input.value = value;
            }
            get Valid() {
                return this._isValid;
            }
            get Keyword() {
                if (!this.Value)
                    return null;
                let keyInstance = {
                    Id: this._masterKeyType.Id,
                    Name: this._masterKeyType.Name,
                    Value: this.Value
                };
                return keyInstance;
            }
            get IsMandatory() {
                // False if we have no data to go on
                if (!this._keyType || !this._keyType.hasOwnProperty('AccessSettings') || (this._keyType.AccessSettings == null))
                    return false;
                switch (this._mode) {
                    case KeywordEditMode.SEARCH:
                        return this._keyType.AccessSettings.RequiredForRetrieval;
                    case KeywordEditMode.UPLOAD:
                    case KeywordEditMode.EDIT:
                        return this._keyType.AccessSettings.RequiredForArchival;
                }
                return false;
            }
            set Placeholder(value) {
                return;
            }
            set KeyUpHandler(value) {
                this._log.info("KeywordEditor.KeyUpHandler()");
                return;
            }
            _buildInterface() {
                console.warn("KeywordEditor base class _buildInterface called - this should not happen!");
            }
            // Need this to prevent single-field forms automatically submitting on enter
            _keyDownHandler(event) {
                if (event.key === "Enter") {
                    event.preventDefault();
                }
            }
        }
        KeywordEditor._counter = 0; // counter used for all instances of needing a unique ID
        // Creator class for the correct instance type
        KeywordEditor.CreateEditor = (core, form, container, id, keyType, value = null, mode = KeywordEditMode.VIEW, changeCallback = null) => {
            let editor = null;
            let editorType = keyType.Type.toLowerCase();
            switch (editorType) {
                case 'numeric9':
                case 'numeric20':
                    editor = new KeywordEditorNumeric(core, form, container, id, keyType, value, mode, changeCallback);
                    break;
                case 'currency':
                case 'specificcurrency':
                    editor = new KeywordEditorCurrency(core, form, container, id, keyType, value, mode, changeCallback);
                    break;
                case 'date':
                    editor = new KeywordEditorDate(core, form, container, id, keyType, value, mode, changeCallback);
                    break;
                case 'datetime':
                    editor = new KeywordEditorDateTime(core, form, container, id, keyType, value, mode, changeCallback);
                    break;
                case 'floatingpoint':
                    editor = new KeywordEditorFloat(core, form, container, id, keyType, value, mode, changeCallback);
                    break;
                default:
                    editor = new KeywordEditorAlphanumeric(core, form, container, id, keyType, value, mode, changeCallback);
                    break;
            }
            return editor;
        };
        MetadataEditors.KeywordEditor = KeywordEditor;
        class KeywordEditorAlphanumeric extends KeywordEditor {
            constructor(core, form, container, id, keyType, value = null, mode = KeywordEditMode.VIEW, changeCallback = null) {
                super(core, form, container, id, keyType, value, mode, changeCallback);
                // UI handling for dataset
                this._selectComponent = null;
                this._inputChanged = (event) => {
                    this._log.info("KeywordEditorAlphanumeric._inputChanged()");
                    if (this._input.checkValidity()) {
                        this._isValid = true;
                        this._valueSet(this._input.value);
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._leaveInput = (event) => {
                    this._log.info("KeywordEditorAlphanumeric._leaveInput()");
                    if (!this._isValid) {
                        this._form.reportValidity();
                    }
                };
                this._selectChanged = (event) => {
                    this._log.info("KeywordEditorAlphanumeric._selectChanged()");
                    if (this._selectComponent.Input.checkValidity()) {
                        this._isValid = true;
                        this._valueSet(this._selectComponent.Input.value);
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._modeSet = (mode) => {
                    this._mode = mode;
                    if (this._mode == KeywordEditMode.VIEW) {
                        this._core.Functions.setInputAbility(this._outerDiv, false, this._input);
                        this._input.required = false;
                    }
                    else {
                        this._core.Functions.setInputAbility(this._outerDiv, true, this._input);
                        this._input.required = this.IsMandatory;
                        if (this._hasDataSet) {
                            this._selectComponent.Input.required = this.IsMandatory;
                            this._core.Functions.hideElement(this._input);
                            this._core.Functions.showElement(this._selectComponent.Input);
                        }
                    }
                };
                this._log.info("KeywordEditorAlphanumeric::constructor");
                this._buildInterface();
            }
            set Placeholder(value) {
                this._input.placeholder = value;
                if (this._selectComponent)
                    this._selectComponent.Input.placeholder = value;
            }
            get Value() { return this._value; }
            set Value(value) {
                this._value = value;
                this._input.value = value;
                if (this._selectComponent)
                    this._selectComponent.Input.value = value;
            }
            set KeyUpHandler(value) {
                this._log.info("KeywordEditorAlphanumeric.KeyUpHandler()");
                if (this._keyupCallback) {
                    this._input.removeEventListener('keyup', this._keyupCallback);
                    if (this._selectComponent)
                        this._selectComponent.Input.removeEventListener('keyup', this._keyupCallback);
                    this._keyupCallback = null;
                }
                if (value) {
                    this._keyupCallback = value;
                    this._input.addEventListener('keyup', value);
                    if (this._selectComponent)
                        this._selectComponent.Input.addEventListener('keyup', value);
                }
            }
            _buildInterface() {
                this._log.info("KeywordEditorAlphanumeric._buildInterface()");
                this._outerDiv = document.createElement('div');
                this._outerDiv.classList.add("wpt-input", "wpt-input--full");
                // Actual input
                this._input = document.createElement('input');
                this._input.type = 'text';
                this._input.addEventListener('change', this._inputChanged);
                this._input.addEventListener('blur', this._leaveInput);
                this._outerDiv.appendChild(this._input);
                this._input.classList.add('wpt-input__input');
                this._outerDiv.appendChild(this._input);
                // Need more stuff for dataset
                if (this._hasDataSet) {
                    let dataSet = {
                        Items: [{ Id: '', DisplayName: '' }]
                    };
                    this._dataSet.forEach(optionValue => { dataSet.Items.push({ Id: optionValue, DisplayName: optionValue }); });
                    let selectOpts = {
                        Options: dataSet,
                        ValueMustExist: this._mustExist,
                        AllowEmptyValue: (this._mode == KeywordEditMode.VIEW) ? true : !this.IsMandatory,
                        ChangeCallback: this._selectChanged
                    };
                    this._selectComponent = new WPTNamespace.Widgets.ComponentOptionInput(this._core, this._outerDiv, null, selectOpts);
                    this._selectComponent.present();
                    this._selectComponent.Input.classList.add(WPTNamespace.HIDDEN_CLASS);
                    this._selectComponent.Input.addEventListener('change', this._selectChanged);
                    this._selectComponent.Input.addEventListener('blur', this._leaveInput);
                }
                if (this._value) {
                    this._input.value = this._value;
                    if (this._selectComponent)
                        this._selectComponent.Input.value = this._value;
                }
                this._input.addEventListener('keydown', this._keyDownHandler);
                this._modeSet(this._mode);
                this._container.appendChild(this._outerDiv);
            }
        }
        MetadataEditors.KeywordEditorAlphanumeric = KeywordEditorAlphanumeric;
        class KeywordEditorCurrency extends KeywordEditor {
            constructor(core, form, container, id, keyType, value = null, mode = KeywordEditMode.VIEW, changeCallback = null) {
                super(core, form, container, id, keyType, value, mode, changeCallback);
                this._display = null;
                this._inputChanged = (event) => {
                    this._log.info("KeywordEditorCurrency._inputChanged()");
                    if (this._input.checkValidity()) {
                        this._isValid = true;
                        this._valueSet(this._input.value);
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._modeSet = (mode) => {
                    this._mode = mode;
                    if (this._mode == KeywordEditMode.VIEW) {
                        this._core.Functions.setInputAbility(this._outerDiv, false, this._display);
                        this._input.required = false;
                        this._display.removeEventListener('focus', this._switchToInput);
                        this._input.removeEventListener('blur', this._switchToDisplay);
                    }
                    else {
                        this._core.Functions.setInputAbility(this._outerDiv, true, this._display);
                        this._input.required = this.IsMandatory;
                        this._display.addEventListener('focus', this._switchToInput);
                        this._input.addEventListener('blur', this._switchToDisplay);
                    }
                };
                this._switchToInput = () => {
                    this._log.info("KeywordEditorCurrency._switchToInput()");
                    this._core.Functions.hideElement(this._display);
                    this._core.Functions.showElement(this._input);
                    this._input.focus();
                };
                this._switchToDisplay = () => {
                    this._log.info("KeywordEditorCurrency._switchToDisplay()");
                    if (!this._isValid) {
                        this._form.reportValidity();
                    }
                    else {
                        this._core.Functions.hideElement(this._input);
                        this._core.Functions.showElement(this._display);
                    }
                };
                this._log.info("KeywordEditorCurrency::constructor");
                this._buildInterface();
            }
            set Placeholder(value) {
                this._display.placeholder = value;
                this._input.placeholder = value;
            }
            get Value() { return this._value; }
            set Value(value) {
                this._value = value;
                this._input.value = value;
                this._display.value = this._core.OBHelper.formatCurrency(value);
            }
            set KeyUpHandler(value) {
                this._log.info("KeywordEditorCurrency.KeyUpHandler()");
                if (this._keyupCallback) {
                    this._input.removeEventListener('keyup', this._keyupCallback);
                    this._keyupCallback = null;
                }
                if (value) {
                    this._keyupCallback = value;
                    this._input.addEventListener('keyup', value);
                }
            }
            _buildInterface() {
                this._log.info("KeywordEditorCurrency._buildInterface()");
                this._outerDiv = document.createElement('div');
                this._outerDiv.classList.add("wpt-input", "wpt-input--full");
                // Display input (to allow proper formatting)
                this._display = document.createElement('input');
                this._display.type = 'text';
                this._outerDiv.appendChild(this._display);
                this._display.classList.add('wpt-input__input');
                // Actual input
                this._input = document.createElement('input');
                this._input.type = 'number';
                this._input.step = '0.01';
                this._input.addEventListener('change', this._inputChanged);
                this._outerDiv.appendChild(this._input);
                this._input.classList.add('wpt-input__input', WPTNamespace.HIDDEN_CLASS);
                if (this._value) {
                    this.Value = this._value;
                }
                this._input.addEventListener('keydown', this._keyDownHandler);
                this._modeSet(this._mode);
                this._container.appendChild(this._outerDiv);
            }
        }
        MetadataEditors.KeywordEditorCurrency = KeywordEditorCurrency;
        class KeywordEditorDate extends KeywordEditor {
            constructor(core, form, container, id, keyType, value = null, mode = KeywordEditMode.VIEW, changeCallback = null) {
                super(core, form, container, id, keyType, value, mode, changeCallback);
                this._display = null;
                this._inputChanged = (event) => {
                    this._log.info("KeywordEditorDate._inputChanged()");
                    if (this._input.checkValidity()) {
                        this._isValid = true;
                        this._valueSet(this._input.value);
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._modeSet = (mode) => {
                    this._mode = mode;
                    if (this._mode == KeywordEditMode.VIEW) {
                        this._core.Functions.setInputAbility(this._outerDiv, false, this._display);
                        this._input.required = false;
                        this._display.removeEventListener('focus', this._switchToInput);
                        this._input.removeEventListener('blur', this._switchToDisplay);
                    }
                    else {
                        this._core.Functions.setInputAbility(this._outerDiv, true, this._display);
                        this._input.required = this.IsMandatory;
                        this._display.addEventListener('focus', this._switchToInput);
                        this._input.addEventListener('blur', this._switchToDisplay);
                    }
                };
                this._switchToInput = () => {
                    this._log.info("KeywordEditorDate._switchToInput()");
                    this._core.Functions.hideElement(this._display);
                    this._core.Functions.showElement(this._input);
                    this._input.focus();
                };
                this._switchToDisplay = () => {
                    this._log.info("KeywordEditorDate._switchToDisplay()");
                    if (!this._isValid) {
                        this._form.reportValidity();
                    }
                    else {
                        this._core.Functions.hideElement(this._input);
                        this._core.Functions.showElement(this._display);
                    }
                };
                this._log.info("KeywordEditorDate::constructor");
                this._buildInterface();
            }
            set Placeholder(value) {
                this._display.placeholder = value;
                this._input.placeholder = value;
            }
            get Value() { return this._value; }
            set Value(value) {
                this._value = value;
                this._input.value = value;
                this._display.value = this._core.OBHelper.formatDate(value);
            }
            set KeyUpHandler(value) {
                this._log.info("KeywordEditorDate.KeyUpHandler()");
                if (this._keyupCallback) {
                    this._input.removeEventListener('keyup', this._keyupCallback);
                    this._keyupCallback = null;
                }
                if (value) {
                    this._keyupCallback = value;
                    this._input.addEventListener('keyup', value);
                }
            }
            _buildInterface() {
                this._log.info("KeywordEditorDate._buildInterface()");
                this._outerDiv = document.createElement('div');
                this._outerDiv.classList.add("wpt-input", "wpt-input--full");
                // Display input (to allow proper formatting)
                this._display = document.createElement('input');
                this._display.type = 'text';
                this._outerDiv.appendChild(this._display);
                this._display.classList.add('wpt-input__input');
                // Actual input
                this._input = document.createElement('input');
                this._input.type = 'date';
                this._input.addEventListener('change', this._inputChanged);
                this._outerDiv.appendChild(this._input);
                this._input.classList.add('wpt-input__input', WPTNamespace.HIDDEN_CLASS);
                if (this._value) {
                    this.Value = this._value;
                }
                this._input.addEventListener('keydown', this._keyDownHandler);
                this._modeSet(this._mode);
                this._container.appendChild(this._outerDiv);
            }
        }
        MetadataEditors.KeywordEditorDate = KeywordEditorDate;
        class KeywordEditorDateTime extends KeywordEditor {
            constructor(core, form, container, id, keyType, value = null, mode = KeywordEditMode.VIEW, changeCallback = null) {
                super(core, form, container, id, keyType, value, mode, changeCallback);
                this._display = null;
                this._timeInput = null;
                this._iconDiv = null;
                this._dateIcon = null;
                this._timeIcon = null;
                this._inputChanged = (event) => {
                    this._log.info("KeywordEditorDateTime._inputChanged()");
                    if (this._input.checkValidity() && this._timeInput.checkValidity()) {
                        this._isValid = true;
                        let resultingValue = "";
                        if (this._input.value != "") {
                            resultingValue = this._input.value;
                            let timeValue = this._timeInput.value;
                            if (timeValue == "") {
                                timeValue = "00:00:00";
                            }
                            resultingValue += "T" + timeValue;
                        }
                        this._valueSet(resultingValue);
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._modeSet = (mode) => {
                    this._mode = mode;
                    if (this._mode == KeywordEditMode.VIEW) {
                        this._core.Functions.setInputAbility(this._outerDiv, false, this._display);
                        this._core.Functions.hideElement(this._iconDiv);
                        this._input.required = false;
                        this._timeInput.required = false;
                        this._display.removeEventListener('focus', this._switchToInput);
                        this._input.removeEventListener('blur', this._switchToDisplay);
                        this._timeInput.removeEventListener('blur', this._switchToDisplay);
                    }
                    else {
                        this._core.Functions.setInputAbility(this._outerDiv, true, this._display);
                        this._core.Functions.showElement(this._iconDiv);
                        this._input.required = this.IsMandatory;
                        this._timeInput.required = this.IsMandatory;
                        this._display.addEventListener('focus', this._switchToInput);
                        this._input.addEventListener('blur', this._switchToDisplay);
                        this._timeInput.addEventListener('blur', this._switchToDisplay);
                    }
                };
                this._switchToInput = () => {
                    this._log.info("KeywordEditorDateTime._switchToInput()");
                    this._core.Functions.hideElement(this._display);
                    this._core.Functions.showElement(this._input);
                    this._core.Functions.showElement(this._timeInput);
                    this._input.focus();
                };
                this._switchToTimeInput = () => {
                    this._log.info("KeywordEditorDateTime._switchToTimeInput()");
                    this._core.Functions.hideElement(this._display);
                    this._core.Functions.showElement(this._input);
                    this._core.Functions.showElement(this._timeInput);
                    this._timeInput.focus();
                };
                this._switchToDisplay = (event) => {
                    this._log.info("KeywordEditorDateTime._switchToDisplay()");
                    if (event.relatedTarget == null || (event.relatedTarget != this._input && event.relatedTarget != this._timeInput && event.relatedTarget != this._dateIcon && event.relatedTarget != this._timeIcon)) {
                        if (!this._isValid) {
                            this._form.reportValidity();
                        }
                        else {
                            this._core.Functions.hideElement(this._input);
                            this._core.Functions.hideElement(this._timeInput);
                            this._core.Functions.showElement(this._display);
                        }
                    }
                };
                this._log.info("KeywordEditorDateTime::constructor");
                this._buildInterface();
            }
            set Placeholder(value) {
                this._display.placeholder = value;
                this._input.placeholder = value;
                this._timeInput.placeholder = value;
            }
            get Value() { return this._value; }
            set Value(value) {
                this._value = value;
                this._display.value = this._core.OBHelper.formatDatetime(this._value);
                if (value != "") {
                    let dateTimeParts = value.split("T");
                    this._input.value = dateTimeParts[0];
                    this._timeInput.value = dateTimeParts[1];
                }
                else {
                    this._input.value = value;
                    this._timeInput.value = value;
                }
            }
            set KeyUpHandler(value) {
                this._log.info("KeywordEditorDateTime.KeyUpHandler()");
                if (this._keyupCallback) {
                    this._input.removeEventListener('keyup', this._keyupCallback);
                    this._timeInput.removeEventListener('keyup', this._keyupCallback);
                    this._keyupCallback = null;
                }
                if (value) {
                    this._keyupCallback = value;
                    this._input.addEventListener('keyup', value);
                    this._timeInput.addEventListener('keyup', value);
                }
            }
            _buildInterface() {
                this._log.info("KeywordEditorDateTime._buildInterface()");
                this._outerDiv = document.createElement('div');
                this._outerDiv.classList.add("wpt-input", "wpt-input--full");
                // Icons to switch between date and time
                this._iconDiv = document.createElement('div');
                this._outerDiv.appendChild(this._iconDiv);
                this._iconDiv.classList.add('wpt-input__icons', 'wpt-input__icons--first', WPTNamespace.HIDDEN_CLASS);
                this._dateIcon = document.createElement('span');
                this._iconDiv.appendChild(this._dateIcon);
                this._dateIcon.classList.add("wpt-input__icons-item", "wpt-input__icons-item--gap-to-right", "wpt-input__icons-item--hover-primary", 'wpt-font', 'wpt-font-icon_Calendar');
                this._dateIcon.addEventListener('click', this._switchToInput);
                this._timeIcon = document.createElement('span');
                this._iconDiv.appendChild(this._timeIcon);
                this._timeIcon.classList.add("wpt-input__icons-item", "wpt-input__icons-item--hover-primary", 'wpt-font', 'wpt-font-icon_History');
                this._timeIcon.addEventListener('click', this._switchToTimeInput);
                // Display input (to allow proper formatting)
                this._display = document.createElement('input');
                this._display.type = 'text';
                this._outerDiv.appendChild(this._display);
                this._display.classList.add('wpt-input__input');
                // Actual input (for date part)
                this._input = document.createElement('input');
                this._input.type = 'date';
                this._input.addEventListener('change', this._inputChanged);
                this._outerDiv.appendChild(this._input);
                this._input.classList.add('wpt-input__input', WPTNamespace.HIDDEN_CLASS);
                // Actual input (for time part)
                this._timeInput = document.createElement('input');
                this._timeInput.type = 'time';
                this._timeInput.step = '1';
                this._timeInput.addEventListener('change', this._inputChanged);
                this._outerDiv.appendChild(this._timeInput);
                this._timeInput.classList.add('wpt-input__input', WPTNamespace.HIDDEN_CLASS);
                if (this._value) {
                    this.Value = this._value;
                }
                this._input.addEventListener('keydown', this._keyDownHandler);
                this._modeSet(this._mode);
                this._container.appendChild(this._outerDiv);
            }
        }
        MetadataEditors.KeywordEditorDateTime = KeywordEditorDateTime;
        class KeywordEditorFloat extends KeywordEditor {
            constructor(core, form, container, id, keyType, value = null, mode = KeywordEditMode.VIEW, changeCallback = null) {
                super(core, form, container, id, keyType, value, mode, changeCallback);
                this._display = null;
                this._inputChanged = (event) => {
                    this._log.info("KeywordEditorFloat._inputChanged()");
                    if (this._input.checkValidity()) {
                        this._isValid = true;
                        this._valueSet(this._input.value);
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._modeSet = (mode) => {
                    this._mode = mode;
                    if (this._mode == KeywordEditMode.VIEW) {
                        this._core.Functions.setInputAbility(this._outerDiv, false, this._display);
                        this._input.required = false;
                        this._display.removeEventListener('focus', this._switchToInput);
                        this._input.removeEventListener('blur', this._switchToDisplay);
                    }
                    else {
                        this._core.Functions.setInputAbility(this._outerDiv, true, this._display);
                        this._input.required = this.IsMandatory;
                        this._display.addEventListener('focus', this._switchToInput);
                        this._input.addEventListener('blur', this._switchToDisplay);
                    }
                };
                this._switchToInput = () => {
                    this._log.info("KeywordEditorFloat._switchToInput()");
                    this._core.Functions.hideElement(this._display);
                    this._core.Functions.showElement(this._input);
                    this._input.focus();
                };
                this._switchToDisplay = () => {
                    this._log.info("KeywordEditorFloat._switchToDisplay()");
                    if (!this._isValid) {
                        this._form.reportValidity();
                    }
                    else {
                        this._core.Functions.hideElement(this._input);
                        this._core.Functions.showElement(this._display);
                    }
                };
                this._log.info("KeywordEditorFloat::constructor");
                this._buildInterface();
            }
            set Placeholder(value) {
                this._display.placeholder = value;
                this._input.placeholder = value;
            }
            get Value() { return this._value; }
            set Value(value) {
                this._value = value;
                this._input.value = value;
                this._display.value = this._core.OBHelper.formatNumber(value);
            }
            set KeyUpHandler(value) {
                this._log.info("KeywordEditorFloat.KeyUpHandler()");
                if (this._keyupCallback) {
                    this._input.removeEventListener('keyup', this._keyupCallback);
                    this._keyupCallback = null;
                }
                if (value) {
                    this._keyupCallback = value;
                    this._input.addEventListener('keyup', value);
                }
            }
            _buildInterface() {
                this._log.info("KeywordEditorFloat._buildInterface()");
                this._outerDiv = document.createElement('div');
                this._outerDiv.classList.add("wpt-input", "wpt-input--full");
                // Display input (to allow proper formatting)
                this._display = document.createElement('input');
                this._display.type = 'text';
                this._outerDiv.appendChild(this._display);
                this._display.classList.add('wpt-input__input');
                // Actual input
                this._input = document.createElement('input');
                this._input.type = 'number';
                this._input.step = '0.000001';
                this._input.addEventListener('change', this._inputChanged);
                this._outerDiv.appendChild(this._input);
                this._input.classList.add('wpt-input__input', WPTNamespace.HIDDEN_CLASS);
                if (this._value) {
                    this.Value = this._value;
                }
                this._input.addEventListener('keydown', this._keyDownHandler);
                this._modeSet(this._mode);
                this._container.appendChild(this._outerDiv);
            }
        }
        MetadataEditors.KeywordEditorFloat = KeywordEditorFloat;
        class KeywordEditorNumeric extends KeywordEditor {
            constructor(core, form, container, id, keyType, value = null, mode = KeywordEditMode.VIEW, changeCallback = null) {
                super(core, form, container, id, keyType, value, mode, changeCallback);
                this._display = null;
                this._selectComponent = null;
                this._inputChanged = (event) => {
                    this._log.info("KeywordEditorNumeric._inputChanged()");
                    if (this._input.checkValidity()) {
                        this._isValid = true;
                        this._valueSet(this._input.value);
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._selectChanged = (event) => {
                    this._log.info("KeywordEditorNumeric._selectChanged()");
                    if (this._selectComponent.Input.checkValidity()) {
                        this._isValid = true;
                        this._valueSet(this._selectComponent.Input.value);
                    }
                    else {
                        this._isValid = false;
                        this._form.reportValidity();
                    }
                };
                this._modeSet = (mode) => {
                    this._mode = mode;
                    if (mode == KeywordEditMode.VIEW) {
                        this._core.Functions.setInputAbility(this._outerDiv, false, this._display);
                        this._input.required = false;
                        this._display.removeEventListener('focus', this._switchToInput);
                        this._input.removeEventListener('blur', this._switchToDisplay);
                        if (this._selectComponent)
                            this._selectComponent.Input.removeEventListener('blur', this._switchToDisplay);
                    }
                    else {
                        this._core.Functions.setInputAbility(this._outerDiv, true, this._display);
                        this._input.required = this.IsMandatory;
                        this._display.addEventListener('focus', this._switchToInput);
                        this._input.addEventListener('blur', this._switchToDisplay);
                        if (this._hasDataSet) {
                            this._selectComponent.Input.required = this.IsMandatory;
                            this._selectComponent.Input.addEventListener('blur', this._switchToDisplay);
                        }
                    }
                };
                this._switchToInput = () => {
                    this._log.info("KeywordEditorNumeric._switchToInput()");
                    this._core.Functions.hideElement(this._display);
                    if (this._hasDataSet) {
                        this._core.Functions.showElement(this._selectComponent.Input);
                        this._selectComponent.Input.focus();
                    }
                    else {
                        this._core.Functions.showElement(this._input);
                        this._input.focus();
                    }
                };
                this._switchToDisplay = () => {
                    this._log.info("KeywordEditorNumeric._switchToDisplay()");
                    if (!this._isValid) {
                        this._form.reportValidity();
                    }
                    else {
                        if (this._hasDataSet) {
                            this._core.Functions.hideElement(this._selectComponent.Input);
                        }
                        else {
                            this._core.Functions.hideElement(this._input);
                        }
                        this._core.Functions.showElement(this._display);
                    }
                };
                this._log.info("KeywordEditorNumeric::constructor");
                this._buildInterface();
            }
            set Placeholder(value) {
                this._display.placeholder = value;
                this._input.placeholder = value;
                if (this._selectComponent)
                    this._selectComponent.Input.placeholder = value;
            }
            get Value() { return this._value; }
            set Value(value) {
                this._value = value;
                this._input.value = value;
                this._display.value = this._core.OBHelper.formatNumber(value);
                if (this._selectComponent)
                    this._selectComponent.Input.value = value;
            }
            set KeyUpHandler(value) {
                this._log.info("KeywordEditorNumeric.KeyUpHandler()");
                if (this._keyupCallback) {
                    this._input.removeEventListener('keyup', this._keyupCallback);
                    if (this._selectComponent)
                        this._selectComponent.Input.removeEventListener('keyup', this._keyupCallback);
                    this._keyupCallback = null;
                }
                if (value) {
                    this._keyupCallback = value;
                    this._input.addEventListener('keyup', value);
                    if (this._selectComponent)
                        this._selectComponent.Input.addEventListener('keyup', value);
                }
            }
            _buildInterface() {
                this._log.info("KeywordEditorNumeric._buildInterface()");
                this._outerDiv = document.createElement('div');
                this._outerDiv.classList.add("wpt-input", "wpt-input--full");
                // Display input (to allow proper formatting)
                this._display = document.createElement('input');
                this._display.type = 'text';
                this._outerDiv.appendChild(this._display);
                this._display.classList.add('wpt-input__input');
                // Actual input
                this._input = document.createElement('input');
                this._input.type = 'number';
                this._input.step = "1";
                this._input.addEventListener('change', this._inputChanged);
                this._outerDiv.appendChild(this._input);
                this._input.classList.add('wpt-input__input', WPTNamespace.HIDDEN_CLASS);
                if (this._hasDataSet) {
                    let dataSet = {
                        Items: [{ Id: '', DisplayName: '' }]
                    };
                    this._dataSet.forEach(optionValue => { dataSet.Items.push({ Id: optionValue, DisplayName: optionValue }); });
                    let selectOpts = {
                        Options: dataSet,
                        ValueMustExist: this._mustExist,
                        AllowEmptyValue: (this._mode == KeywordEditMode.VIEW) ? true : !this.IsMandatory,
                        ChangeCallback: this._selectChanged
                    };
                    this._selectComponent = new WPTNamespace.Widgets.ComponentOptionInput(this._core, this._outerDiv, null, selectOpts);
                    this._selectComponent.present();
                    this._selectComponent.Input.classList.add(WPTNamespace.HIDDEN_CLASS);
                    this._selectComponent.Input.type = 'number';
                    this._selectComponent.Input.step = "1";
                    this._selectComponent.Input.addEventListener('change', this._selectChanged);
                }
                if (this._value) {
                    this.Value = this._value;
                }
                this._input.addEventListener('keydown', this._keyDownHandler);
                this._modeSet(this._mode);
                this._container.appendChild(this._outerDiv);
            }
        }
        MetadataEditors.KeywordEditorNumeric = KeywordEditorNumeric;
        // Wrapper may be invisible for Standalone, SIGKs and for all search-type conmponents
        class KeywordGroupWrapper {
            constructor(core, form, container, id, recordType, recordInstance, mode, unrestrictedUser = false, suppressHeading = false, simpleEditors = false, include = null, exclude = null, insertAfter = null) {
                this._core = null;
                this._log = null;
                this._form = null;
                this._id = null;
                this._container = null;
                this._outerElement = null;
                this._keyListRoot = null;
                this._mode = null;
                this._insertAfter = null;
                this._userCanAccessRestrictedKeys = false;
                this.AddCallback = null;
                this.CheckForRemoveCallback = null;
                this.RemoveCallback = null;
                // Need some error handlers so owners can pass them in
                this.ErrorCallback = null;
                this.FailCallback = null;
                // Data
                this._recordType = null;
                this._recordInstance = null;
                this._editors = [];
                this._includeKeys = [];
                this._excludeKeys = [];
                // Buttons etc.
                this._addButton = null;
                this._removeButton = null;
                this._toggleSpan = null;
                this._buildInterface = () => {
                    this._outerElement = document.createElement('li');
                    // Split into two DIVs - one at the top for controls, one under for actual editor
                    if (!this._suppressHeading) {
                        let topDiv = document.createElement('div');
                        topDiv.classList.add('reqs-list', 'keywordrecord-sublist', 'widget__subheader', 'widget__subheader--no-right-padding');
                        let leftSpan = document.createElement('span');
                        leftSpan.addEventListener('click', this._groupToggleClicked);
                        this._toggleSpan = document.createElement('span');
                        this._toggleSpan.classList.add('wpt-font', 'wpt-font-icon_Up', 'keywordrecord-item__icon');
                        leftSpan.appendChild(this._toggleSpan);
                        let labelSpan = document.createElement('span');
                        labelSpan.classList.add('keywordrecord-item__name');
                        labelSpan.innerText = (this._recordType.Type == 'StandAlone') ? this._core.Locale.getTranslation('STR_WPT_STD_KEY_TYPES') : this._recordType.TranslatedName;
                        leftSpan.appendChild(labelSpan);
                        topDiv.appendChild(leftSpan);
                        // Right Span for add and remove button
                        let rightSpan = document.createElement('span');
                        rightSpan.classList.add('keywordrecord-item__icons', 'keywordrecord-item__rightspan');
                        if (this._recordType.Type == 'MultiInstance') {
                            this._removeButton = document.createElement('span');
                            this._removeButton.classList.add('wpt-font', 'wpt-font-indeterminate_check_box', 'keywordrecord-item__icon', 'kweditor-span-button');
                            this._removeButton.addEventListener('click', this._groupRemoveClicked);
                            rightSpan.appendChild(this._removeButton);
                            this._addButton = document.createElement('span');
                            this._addButton.classList.add('wpt-font', 'wpt-font-add_box', 'keywordrecord-item__icon', 'kweditor-span-button');
                            this._addButton.addEventListener('click', this._groupAddClicked);
                            rightSpan.appendChild(this._addButton);
                        }
                        topDiv.appendChild(rightSpan);
                        this._outerElement.appendChild(topDiv);
                    }
                    // Create place for keyword editor wrappers
                    this._keyListRoot = document.createElement('ul');
                    this._outerElement.appendChild(this._keyListRoot);
                    this._insertEditors();
                    this._applyEditMode();
                    if (this._insertAfter && this._insertAfter.nextSibling != null) {
                        this._container.insertBefore(this._outerElement, this._insertAfter.nextSibling);
                    }
                    else
                        this._container.appendChild(this._outerElement);
                };
                this._insertEditors = () => {
                    let editorCallbacks = {
                        DataChangedCallback: this._keyChangedCallback,
                        RowAddedCallback: this._editorAddRequest
                    };
                    for (let i = 0; i < this._recordType.KeywordTypes.length; i++) {
                        let keyType = this._recordType.KeywordTypes[i];
                        // Filter on include/exclude lists                
                        if ((this._includeKeys.length > 0) && (this._includeKeys.indexOf(keyType.Name) == -1))
                            continue;
                        else if ((this._excludeKeys.length > 0) && (this._excludeKeys.indexOf(keyType.Name) > -1))
                            continue;
                        let keyInstances = (this._recordInstance) ? this._recordInstance.Keywords.filter(k => (k.Name == keyType.Name)) : [];
                        if (keyInstances.length > 0) {
                            keyInstances.forEach(keyInstance => {
                                let wrapper = new KeywordEditorWrapper(this._core, this._form, this._keyListRoot, null, keyInstance, keyType, this, this._simpleEditors, editorCallbacks, this._mode);
                                this._editors.push(wrapper);
                            });
                        }
                        else {
                            let wrapper = new KeywordEditorWrapper(this._core, this._form, this._keyListRoot, null, null, keyType, this, this._simpleEditors, editorCallbacks, this._mode);
                            this._editors.push(wrapper);
                        }
                    }
                };
                this._groupAddClicked = (event) => {
                    // Clone ourselves and hand back - if we have nobody to inform, don't do anything!
                    if (this.AddCallback) {
                        let clone = new KeywordGroupWrapper(this._core, this._form, this._container, WPTNamespace.Widgets.ComponentKeywordsBase.CounterString, this._recordType, null, this._mode, this._userCanAccessRestrictedKeys, this._suppressHeading, this._simpleEditors, this._includeKeys, this._excludeKeys, this._outerElement);
                        clone.AddCallback = this.AddCallback;
                        clone.RemoveCallback = this.RemoveCallback;
                        clone.CheckForRemoveCallback = this.CheckForRemoveCallback;
                        this.AddCallback(clone);
                    }
                };
                this._groupRemoveClicked = (event) => {
                    this._log.info("KeywordGroupWrapper::_groupRemoveClicked");
                    // Ask if we can delete - if no check function passed in we assume "yes"
                    if (this.CheckForRemoveCallback) {
                        this._log.trace("KeywordGroupWrapper::_groupRemoveClicked has check callback available.");
                        // Tell the parent we have to go
                        if (this.CheckForRemoveCallback(this)) {
                            this._outerElement.remove();
                            if (this.RemoveCallback)
                                this.RemoveCallback(this);
                        }
                        else {
                            // Just clear the values so they can be reentered
                            this.clearValues();
                        }
                    }
                    else {
                        this._log.trace("KeywordGroupWrapper::_groupRemoveClicked has no check callback available.");
                        this._outerElement.remove();
                        if (this.RemoveCallback)
                            this.RemoveCallback(this);
                    }
                };
                this._editorAddRequest = (keyType, insertAfter = null) => {
                    let editorCallbacks = { RowAddedCallback: this._editorAddRequest };
                    let wrapper = new KeywordEditorWrapper(this._core, this._form, this._keyListRoot, insertAfter, null, keyType, this, this._simpleEditors, editorCallbacks, this._mode);
                    this._editors.push(wrapper);
                };
                this._groupToggleClicked = (event) => {
                    if (this._keyListRoot.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                        this._core.Functions.showElement(this._keyListRoot);
                        this._toggleSpan.classList.remove('wpt-font-icon_Down');
                        this._toggleSpan.classList.add('wpt-font-icon_Up');
                    }
                    else {
                        this._core.Functions.hideElement(this._keyListRoot);
                        this._toggleSpan.classList.remove('wpt-font-icon_Up');
                        this._toggleSpan.classList.add('wpt-font-icon_Down');
                    }
                };
                this._keyChangedCallback = (keyType, value) => {
                    // Need to know if this keyword is an autofill primary
                    if (keyType.hasOwnProperty('AutofillKeywordSetId') && (keyType.AutofillKeywordSetId != null) && (keyType.AutofillKeywordSetId > 0)) {
                        // If we get here, it's an autofill primary. Need to go get the secondaries...
                        let requestData = {
                            Id: keyType.AutofillKeywordSetId,
                            Value: value
                        };
                        this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/GetKeysetData', JSON.stringify(requestData), this._autofillContentReturned.bind(this, keyType), null, this.ErrorCallback, this.FailCallback);
                    }
                };
                this._autofillContentReturned = (keyType, response) => {
                    if ((response.hasOwnProperty('DataSet')) && (response.DataSet) && (response.DataSet.length > 0)) {
                        if (response.DataSet.length == 1) {
                            this._applyAutofill(keyType, response.DataSet[0]);
                        }
                        else {
                            this._core.Helper.presentAutofillDatasetSelectionModal(WPTNamespace.ModalType.FIRST, response.DataSet, this._applyAutofill.bind(this, keyType));
                        }
                    }
                };
                this._applyAutofill = (keyType, keySet) => {
                    keySet.Keywords.forEach(key => {
                        // Filter out the actual primary, we already set that
                        if (key.Id != keyType.Id) {
                            // Want an iterator type loop so we can continue when we hit the first instance
                            for (let i = 0; i < this._editors.length; i++) {
                                if (this._editors[i].KeywordType.Id == key.Id) {
                                    this._editors[i].Value = key.Value;
                                    continue;
                                }
                            }
                        }
                    });
                };
                this.clearValues = () => {
                    this._editors.forEach(editor => editor.Value = '');
                };
                // May call with false on initial build as editors already know their mode
                this._applyEditMode = () => {
                    switch (this._mode) {
                        case KeywordEditMode.VIEW:
                            if (this.RecordGroupType == `MultiInstance`) {
                                this._core.Functions.hideElement(this._addButton);
                                this._core.Functions.hideElement(this._removeButton);
                            }
                            if ((this.RecordGroupType == `MultiInstance`) || (this.RecordGroupType == `SingleInstance`)) {
                                if (this.HasValues)
                                    this._core.Functions.showElement(this._outerElement);
                                else
                                    this._core.Functions.hideElement(this._outerElement);
                            }
                            else
                                this._core.Functions.showElement(this._outerElement);
                            break;
                        case KeywordEditMode.EDIT:
                            if (this.RecordGroupType == `MultiInstance`) {
                                this._core.Functions.showElement(this._addButton);
                                this._core.Functions.showElement(this._removeButton);
                            }
                            this._core.Functions.showElement(this._outerElement);
                            break;
                        case KeywordEditMode.SEARCH:
                            // Only standalone types, so don't do anything.
                            this._core.Functions.showElement(this._outerElement);
                            break;
                        case KeywordEditMode.UPLOAD:
                            if (this.RecordGroupType == `MultiInstance`) {
                                this._core.Functions.showElement(this._addButton);
                                this._core.Functions.showElement(this._removeButton);
                            }
                            this._core.Functions.showElement(this._outerElement);
                            break;
                    }
                    this._editors.forEach(editor => {
                        if (editor.ReadOnly && !this._userCanAccessRestrictedKeys) {
                            if ((this._mode == KeywordEditMode.EDIT) || (this._mode == KeywordEditMode.UPLOAD))
                                editor.Mode = KeywordEditMode.VIEW;
                            else
                                editor.Mode = this._mode;
                        }
                        else
                            editor.Mode = this._mode;
                    });
                };
                this._core = core;
                this._log = core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("KeywordGroupWrapper::constructor");
                this._form = form;
                this._container = container;
                this._id = id;
                this._mode = mode;
                this._recordType = recordType;
                this._recordInstance = recordInstance;
                this._userCanAccessRestrictedKeys = unrestrictedUser;
                this._suppressHeading = suppressHeading;
                this._simpleEditors = simpleEditors;
                this._insertAfter = insertAfter;
                if (include)
                    this._includeKeys = include;
                if (exclude)
                    this._excludeKeys = exclude;
                if ((this._recordType.ReadOnly) && (this._mode == KeywordEditMode.EDIT))
                    this._mode = KeywordEditMode.VIEW;
                this._buildInterface();
            }
            set KeyUpHandler(handler) {
                if (handler) {
                    this._editors.forEach(editor => {
                        editor.KeyUpHandler = handler;
                    });
                }
            }
            get Mode() {
                return this._mode;
            }
            set Mode(value) {
                if ((this._recordType.ReadOnly) && (value == KeywordEditMode.EDIT))
                    this._mode = KeywordEditMode.VIEW;
                else
                    this._mode = value;
                this._applyEditMode();
            }
            get Id() {
                return this._id;
            }
            get RecordGroupType() {
                return this._recordType.Type;
            }
            get RecordType() {
                return this._recordType;
            }
            get FlexTerms() {
                let terms = [];
                this._editors.forEach(editor => {
                    let term = editor.FlexTerm;
                    if (term) {
                        if (term.Term == '>>DateSingle') {
                            // DateSingle not recognised by FlexSearch, need to splt into "to" and "from" entries
                            term.Term = '>>DateFrom';
                            let toTerm = JSON.parse(JSON.stringify(term));
                            toTerm.Term = '>>DateTo';
                            terms.push(toTerm);
                        }
                        terms.push(term);
                    }
                });
                return terms;
            }
            get KeywordRecord() {
                let record = {
                    Id: this._recordType.Id,
                    Name: this._recordType.Name,
                    Type: this._recordType.Type,
                    Keywords: []
                };
                this._editors.forEach(editor => {
                    let keyInstance = editor.KeywordInstance;
                    if ((keyInstance != null) && (keyInstance.Id > 0))
                        record.Keywords.push(keyInstance);
                });
                return record;
            }
            get Properties() {
                let props = [];
                this._editors.forEach(editor => {
                    let keyInstance = editor.KeywordInstance;
                    if ((keyInstance != null) && (keyInstance.Id < 0))
                        props.push(keyInstance);
                });
                return props;
            }
            get HasValues() {
                let valueFound = false;
                this._editors.forEach(editor => { if (editor.Value)
                    valueFound = true; });
                return valueFound;
            }
            get HasProperties() {
                let propFound = false;
                this._editors.forEach(editor => {
                    let keyInstance = editor.KeywordInstance;
                    if ((keyInstance != null) && (keyInstance.Id < 0))
                        propFound = true;
                });
                return propFound;
            }
            get HasKeywords() {
                let keyFound = false;
                this._editors.forEach(editor => {
                    let keyInstance = editor.KeywordInstance;
                    if ((keyInstance != null) && (keyInstance.Id > 0))
                        keyFound = true;
                });
                return keyFound;
            }
            get Valid() {
                let valid = true;
                this._editors.forEach(editor => {
                    if (!editor.Valid)
                        valid = false;
                });
                return valid;
            }
            get UserCanAccessRestrictedKeys() { return this._userCanAccessRestrictedKeys; }
        }
        // We don't want to create keyword groups if they are going to be empty, validate here
        KeywordGroupWrapper.HasKeywords = (recordType, includeKeywords, excludeKeywords) => {
            // Stupid but possible with odd service layer configs
            if (!recordType.hasOwnProperty('KeywordTypes') || (recordType.KeywordTypes == null) || (recordType.KeywordTypes.length == 0))
                return false;
            // Sanitise inputs
            let includeList = (includeKeywords != null) ? includeKeywords : [];
            let excludeList = (excludeKeywords != null) ? excludeKeywords : [];
            if ((includeList.length == 0) && (excludeList.length == 0))
                return true;
            // Includes take precedence
            let keyIncluded = false;
            if (includeList.length > 0)
                recordType.KeywordTypes.forEach(keyType => { if (includeList.indexOf(keyType.Name) > -1)
                    keyIncluded = true; });
            else
                recordType.KeywordTypes.forEach(keyType => { if (excludeList.indexOf(keyType.Name) == -1)
                    keyIncluded = true; });
            return keyIncluded;
        };
        MetadataEditors.KeywordGroupWrapper = KeywordGroupWrapper;
    })(MetadataEditors = WPTNamespace.MetadataEditors || (WPTNamespace.MetadataEditors = {}));
})(WPTNamespace || (WPTNamespace = {}));
